<template>
  <Layout class="app-layout" :class="{'app-layout--collpase': isCollapsed || appBreakpoint}">
    <AppSider/>
    <Layout class="app-main">
      <AppHeader/>
      <router-view/>
<!--      <keep-alive :include="postjobstep1,postjobstep2">-->
<!--      </keep-alive>-->
    </Layout>
  </Layout>
</template>
<script>
import Vue from 'vue'

import AppHeader from '../../components/layouttoc/AppHeader.vue'
import AppSider from '../../components/layouttoc/AppSider.vue'
import AppMenu from '../../components/layouttoc/AppMenu.vue'
import AppPageTitle from '../../components/layouttoc/AppPageTitle.vue'

Vue.component('AppPageTitle', AppPageTitle)
Vue.component('AppMenu', AppMenu)

export default {
  components: {
    AppHeader,
    AppSider,
  },
  computed: {
    isCollapsed () {
      return this.$store.state.isCollapsed
    },
    appBreakpoint () {
      return this.$store.state.appBreakpoint
    }
  }
}
</script>
<style lang="less">
@import "../../assets/less/base/variables.less";
.app-layout {
  background-color: @body-background;
  &.app-layout--collpase {
    .app-main {
      padding-left: 64px;
    }
    .app-header {
      left: 64px;
    }
    @media (max-width: 600px) {
      .app-main {
        padding-left: 0;
      }
      .app-header {
        left: 0;
      }
    }
  }
}
.app-main {
  padding-left: 216px;
  position: relative;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  flex: auto;
  transition: all @animation-time;
  z-index: 1;
  background: transparent !important;
}
.app-content {
  padding: 56px 24px 0 24px;
  flex: auto;
  &__main {
    padding: 24px;
    margin: 24px 0;
    transition: all @animation-time;
    background: #fff;
    border-radius: 4px;
  }
}
</style>
